import styled from 'styled-components';
import { cssprops } from '@vfit/shared/themes';
import { ILinkStyledComponent } from '../../link.models';
import * as S from '../../link.style';

export const Button = styled.button<ILinkStyledComponent>`
  border: none;
  cursor: pointer;
  padding: 0;
  ${({ variant }) => (variant === 'regular' ? 'text-decoration: underline;' : '')}
  ${S.common}

  &:disabled {
    ${S.disabled}
  }

  ${cssprops.styled}
`;

